import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=80ac2020"
import script from "./AccountDropdown.vue?vue&type=script&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports